import type { IAppConfigProvider } from "../../application/interfaces/IAppConfigProvider";
import { AppConfig } from "./AppConfig";
export class ConfigProvider implements IAppConfigProvider {
    config: AppConfig | null = null

    async getAppConfig(): Promise<AppConfig> {
            if (this.config) return this.config
            throw new Error("config not loaded")
    }
    initConfig(apiUrl: string, apiKey: string): void {
        // darf nicht async sein da in App.vue Setup aufgerufen
        this.config = new AppConfig(apiUrl, apiKey);
    }
    
}